
import { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingScreen from '@/components/assessment/LoadingScreen';
import useAdmin from '@/hooks/useAdmin';
import { toast } from 'sonner';

interface AdminProtectedRouteProps {
  children: ReactNode;
}

const AdminProtectedRoute = ({ children }: AdminProtectedRouteProps) => {
  const { isAdmin, loading } = useAdmin();
  const location = useLocation();
  
  useEffect(() => {
    // Log admin authentication status for debugging
    console.log('Admin route protection status:', { 
      isAdmin, 
      loading, 
      path: location.pathname 
    });
  }, [isAdmin, loading, location.pathname]);
  
  // If still checking authentication, show loading
  if (loading) {
    return <LoadingScreen message="Verifying admin credentials..." />;
  }
  
  // If not an admin, redirect to admin login
  if (!isAdmin) {
    console.log('Not admin, redirecting to login');
    // Show toast only on initial navigation, not on refresh
    if (location.state?.fromProtectedRoute !== true) {
      toast.error('You must be logged in as an administrator to access this page');
    }
    return <Navigate 
      to="/administrator/login" 
      state={{ from: location, fromProtectedRoute: true }} 
      replace 
    />;
  }
  
  // If authenticated and an admin, render children
  console.log('Admin authenticated, rendering protected content');
  return <>{children}</>;
};

export default AdminProtectedRoute;
